import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useState } from "react"
import SssAccordionItem from "../../components/shared/accordion/SssAccordionItem"
import { useSelector } from "react-redux"

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;
    }

    .list{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;



    }
}
`

const SikcaSorulanSorular = () => {

    const {SSSList} = useSelector(state => state.adminSett)
    const [sss, setSss] = useState(SSSList)



    const handleClick = (item) => {
        const updated = sss.map((sssItem) => {
            if(sssItem.id === item.id){
                return {...sssItem, isOpened: item.isOpened ? false: true}
            }
            else{
                return {...sssItem, isOpened: false}
            }
        })
        setSss(updated)
    }

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Sıkça Sorulan Sorular"} position='sticky'/>
      <div className="content">
        <div className="list">
            {
                sss.map((item) => (
                    <SssAccordionItem item={item} handleClick={handleClick} />
                ))
            }
        </div>
      </div>
    </div>
  </Container>
  )
}

export default SikcaSorulanSorular